import Grid from '@mui/material/Grid';
import {localized} from 'i18n/i18n';
import {FC, memo} from 'react';
import {StatisticItem, getValueOrUnknown} from './statistic-item';
import {SmallStatisticItemWrapper} from './statistic-item-container';
import {StatisticsProps} from './statistics';
import {StatisticItemRoot} from './statistics-container-item';

export const PWStatistics: FC<StatisticsProps> = memo((props) => {
  const {machine} = props;

  if (!machine?.latestStatistics) {
    return <div>{localized('NoStatistics')}</div>;
  }

  const {totalWashHours, washHoursSinceService, washesLeftBeforeFilterChange, washesLeftBeforeService} =
    machine.latestStatistics;

  return (
    <Grid
      container
      spacing={{
        xs: 5,
        xl: 6,
      }}>
      <StatisticItemRoot xs={12} lg={3}>
        <SmallStatisticItemWrapper>
          <StatisticItem label={localized('TotalWashHours')} placeholder={getValueOrUnknown(totalWashHours)} />
          <StatisticItem
            label={localized('WashHoursSinceService')}
            placeholder={getValueOrUnknown(washHoursSinceService)}
          />
        </SmallStatisticItemWrapper>
      </StatisticItemRoot>

      <StatisticItemRoot xs lg>
        <StatisticItem
          label={localized('WashHoursLeftBeforeService')}
          placeholder={getValueOrUnknown(washesLeftBeforeService)}
          variant="large"
        />
      </StatisticItemRoot>

      <StatisticItemRoot xs lg>
        <StatisticItem
          label={localized('WashHoursLeftBeforeFilterChange')}
          placeholder={getValueOrUnknown(washesLeftBeforeFilterChange)}
          variant="large"
        />
      </StatisticItemRoot>
    </Grid>
  );
});
